import { computed } from "@ember/object";
import { classNameBindings } from "@ember-decorators/component";
import deprecated from "discourse/lib/deprecated";
import { allowOnlyNumericInput } from "discourse/lib/utilities";
import DTextField from "discourse/ui-kit/d-text-field";
import { i18n } from "discourse-i18n";

@classNameBindings("invalid")
export default class DNumberField extends DTextField {
  init() {
    super.init(...arguments);
    deprecated(
      `NumberField component is deprecated. Use native <input> elements instead.\ne.g. <input {{on "input" (with-event-value (fn (mut this.value)))}} type="number" value={{this.value}} />`,
      {
        id: "discourse.number-field",
        since: "3.2.0.beta5",
      }
    );
  }

  @computed("number")
  get value() {
    if (this.number === null) {
      return "";
    }
    return parseInt(this.number, 10);
  }

  set value(value) {
    const num = parseInt(value, 10);
    if (isNaN(num)) {
      this.set("invalid", true);
      this.set("number", null);
    } else {
      this.set("invalid", false);
      this.set("number", num);
    }
  }

  get _minNumber() {
    if (!this.get("min")) {
      return;
    }
    return parseInt(this.get("min"), 10);
  }

  get _maxNumber() {
    if (!this.get("max")) {
      return;
    }
    return parseInt(this.get("max"), 10);
  }

  @computed("placeholderKey")
  get placeholder() {
    return this.placeholderKey ? i18n(this.placeholderKey) : "";
  }

  keyDown(event) {
    allowOnlyNumericInput(event, this._minNumber && this._minNumber < 0);
  }
}
